import { FieldValues, Path, UseFormRegister } from "react-hook-form";
import { lang } from "../../assets/languages/en.language";
import { formConfig } from "../../configs/form.config";
import { FormLabel, StyledInput, StyledInputWrapper } from "../../styles/Form";
import { Gap } from "../../styles/Utils";

interface UserNameInputProps<T extends FieldValues> {
  register: UseFormRegister<T>; // Register function from RHF
  name: Path<T>; // The field name should be a key from the form data type
  disabled?: boolean;
}

export default function UserNameInput<T extends FieldValues>({ register, name }: UserNameInputProps<T>) {
  return (
    <StyledInputWrapper>
      <FormLabel>{lang?.signUpPage.form.name.label}</FormLabel>
      <Gap $height={0.5} />
      <StyledInput
        {...register(name, {
          required: true,
          pattern: {
            value: formConfig.name.pattern,
            message: lang.inputs.namePattern,
          },
        })}
        placeholder={lang.signUpPage.form.name.placeholder}
      />
    </StyledInputWrapper>
  );
}
